import { AfterViewInit, Component } from '@angular/core';
import { TicketValidationStatus } from '../../entity/TicketValidationStatus';
import { TicketResponse } from '../../entity/TicketResponse';
import { Ticket } from '../../entity/Ticket';
import { TicketValidatorService } from '../../service/ticket-validator.service';
import { environment } from 'src/environments/environment';
import { TicketSaleService } from 'src/app/service/ticket-sale.service';
import { NgxSpinnerService } from "ngx-spinner";
import { finalize, Observable } from 'rxjs';


@Component({
    selector: 'app-ticket',
    templateUrl: './ticket.component.html',
    styleUrls: ['./ticket.component.scss'],
    standalone: false
})
export class TicketComponent implements AfterViewInit {

  mode: string = 'validate';

  ticketResponse: TicketResponse = { status: TicketValidationStatus.UNKNOWN } as TicketResponse;

  offline: boolean = false;

  private isWaitingResponse: boolean = false;

  private lastReadTime: Date = new Date();

  constructor(private spinner: NgxSpinnerService, private ticketValidatorService: TicketValidatorService) { 
  }

  ngAfterViewInit(): void {
    this.offline = this.ticketValidatorService.isOfflineMode();
  }

  public scanSuccessHandler(result: string): void {
    this.spinner.show();
    if(!this.isWaitingResponse && (new Date(this.lastReadTime.getTime() + environment.SCANNER_READ_LOCK_SECONDS) < new Date())){
      this.isWaitingResponse = true;
      this.reset();
      this.lastReadTime = new Date();
      this.measureMetrics();
      this.handleTicket(result).pipe(finalize(() => this.isWaitingResponse = false))
      .subscribe(data => {
        this.ticketResponse = data;
        this.spinner.hide();
      });
    }
  }

  public reset(){
     this.ticketResponse = { status: TicketValidationStatus.UNKNOWN } as TicketResponse;
  }

  private handleTicket(ticketToken: string): Observable<TicketResponse> {

      const ticket = { validity_token: ticketToken } as Ticket;

   
      return this.ticketValidatorService.validateTicket(ticket);
  }

  private measureMetrics(): void {
    localStorage.setItem("scan_counter" , (parseInt(localStorage.getItem("scan_counter") || "0") + 1).toString() );
  }

}
